// extracted by mini-css-extract-plugin
export default {"container":"radio_container__XMUK9"};